import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { LicenseModel } from 'types'
import LicensesDataGrid from 'components/LicenseDataGrid'

export default function LicensesPage() {
  const licenses = useLoaderData() as LicenseModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Licences">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/license')}>
            Créer une licence
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          {/* --- UPDATED: Pass the filtered data to the DataGrid --- */}
          <LicensesDataGrid licenses={licenses} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
